import { useState } from "react";
import { Button } from "V2.0/common/button";
import { PlusIcon, XMarkIcon } from "@heroicons/react/16/solid";
import { Dialog, DialogBody, DialogTitle } from "V2.0/common/dialog";
import { SMSTriggerForm } from "./SMSTriggerForm";

function SMSTriggerCreate({ onTriggerCreate }) {
  const [open, setOpen] = useState(false);

  const handleSubmit = (data, lifecycleCbs) => {
    onTriggerCreate(data, lifecycleCbs);
  };

  return (
    <>
      <Button color="white" onClick={() => setOpen(true)}>
        <PlusIcon />
        Add Trigger
      </Button>
      <Dialog
        className=""
        size="lg"
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle>Add SMS Trigger</DialogTitle>
        <DialogBody className="text-sm/6">
          <SMSTriggerForm
            smsTrigger={{}}
            onCancel={() => setOpen(false)}
            onSubmit={handleSubmit}
          />
        </DialogBody>
      </Dialog>
    </>
  );
}

export { SMSTriggerCreate };
